import type { Theme } from 'theme-ui';

const theme: Theme = {
	breakpoints: ['600px', '960px'],
	space: [0, 4, 8, 12, 16, 24, 32, 48, 64, 96, 128, 192, 256, 384, 512],
	fonts: {
		heading: '"Noto Serif", Georgia, serif',
		body: 'Literata, "Noto Serif", Georgia, serif',
		body2:
			'"Work Sans", "Avant Garde", "Century Gothic", "Google Sans", "Product Sans", Manrope, "SF Pro Display", Roboto, "Lucida Sans", Arial, sans-serif',
	},
	borders: {
		primary: '1px solid #0c0715',
		accent: '1px solid #691bff',
	},
	fontSizes: [12, 15, 18, 21, 24, 32, 48, 64, 96],
	fontWeights: {
		heading: 700,
		subtitle: 600,
		body: 400,
	},
	shadows: {
		longHover: {
			inactive: '0 0 0 0 #0c0715',
			active: '4px 4px 0 0 #0c0715',
		},
	},
	lineHeights: {
		heading: 1.125,
		body: 1.778,
		body2: 1.5,
	},
	letterSpacings: {
		tight: '-0.025em',
		wide: '0.015em',
		wider: '0.05em',
	},
	text: {
		title: {
			color: 'text.primary',
			letterSpacing: 'tight',
			fontFamily: 'heading',
			fontWeight: 'heading',
			fontSize: 7,
			lineHeight: 'heading',
			mt: 4,
		},
		heading: {
			color: 'text.primary',
			fontFamily: 'body2',
			fontWeight: 'heading',
			fontSize: 4,
			lineHeight: 'heading',
			letterSpacing: 'tight',
			mt: 4,
		},
		subtitle: {
			color: 'text.secondary',
			fontFamily: 'body2',
			fontWeight: 'subtitle',
			fontSize: 1,
			lineHeight: 'heading',
			letterSpacing: 'wider',
			my: 1,
		},
		body: {
			color: 'text.primary',
			fontFamily: 'body',
			lineHeight: 'body',
			fontWeight: 'body',
			fontSize: 2,
			hyphens: 'auto',
			my: 4,
		},
		quote: {
			color: 'text.primary',
			fontFamily: 'body',
			lineHeight: 'body',
			fontWeight: 'body',
			fontSize: 2,
			pl: 4,
			borderLeftWidth: 4,
			borderLeftStyle: 'solid',
			borderColor: 'text.secondary',
			my: 4,
		},
		button: {
			color: 'accent',
			fontFamily: 'body2',
			lineHeight: 'body',
			fontWeight: 'body',
			letterSpacing: 'wide',
			fontSize: 2,
		},
		footnote: {
			color: 'text.primary',
			fontFamily: 'body',
			lineHeight: 'body',
			fontWeight: 'body',
			fontSize: 1,
		},
		promo: {
			color: 'text.primary',
			fontFamily: 'body2',
			lineHeight: 'body2',
			fontWeight: 'body',
			fontSize: 3,
			letterSpacing: 'wide',
		},
		// TODO remove these markers. they're here just to ensure I don't forget to style anything explicitly.
		default: {
			color: 'red',
			fontFamily: 'Comic Sans MS',
			lineHeight: 'body',
			fontWeight: 'body',
		},
		paragraph: {
			color: 'blue',
			fontFamily: 'Comic Sans MS',
			lineHeight: 'body',
			fontWeight: 'body',
		},
	},
	colors: {
		text: {
			primary: '#0c0715',
			secondary: '#1b0f33',
		},
		background: '#fff',
		accentBackground: '#f7f2ff',
		accent: '#691bff',
	},
	styles: {
		root: {},
		a: {
			color: 'inherit',
			textDecoration: 'none',
			fontWeight: 'heading',
			letterSpacing: 'wide',
			'&.active': { opacity: 0.75 },
		},
		hr: {
			borderTop: 1,
			borderColor: 'text.secondary',
			my: 5,
		},
	},
};

export default theme;
